var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19,5H17V3H7V5H5A2.006,2.006,0,0,0,3,7V8a4.991,4.991,0,0,0,4.39,4.94A5.009,5.009,0,0,0,11,15.9V19H7v2H17V19H13V15.9a5.009,5.009,0,0,0,3.61-2.96A4.991,4.991,0,0,0,21,8V7A2.006,2.006,0,0,0,19,5ZM5,8V7H7v3.82A3.01,3.01,0,0,1,5,8Zm7,6a3.009,3.009,0,0,1-3-3V5h6v6A3.009,3.009,0,0,1,12,14Zm7-6a3.01,3.01,0,0,1-2,2.82V7h2Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.7a02a5b7.svg";
export { ForwardRef as ReactComponent };